import script from './component-lib.esm18.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'Mastodon social media'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M30.924 10.505c0-6.941-4.548-8.976-4.548-8.976-2.293-1.053-6.232-1.496-10.321-1.529h-0.101c-4.091 0.033-8.027 0.476-10.32 1.529 0 0-4.548 2.035-4.548 8.976 0 1.589-0.031 3.491 0.020 5.505 0.165 6.789 1.245 13.479 7.521 15.14 2.893 0.765 5.379 0.927 7.38 0.816 3.629-0.2 5.667-1.296 5.667-1.296l-0.12-2.633c0 0-2.593 0.817-5.505 0.719-2.887-0.099-5.932-0.311-6.399-3.855-0.041-0.29-0.064-0.626-0.064-0.967 0-0.009 0-0.018 0-0.028v0.001c0 0 2.833 0.693 6.423 0.857 2.195 0.1 4.253-0.129 6.344-0.377 4.009-0.479 7.5-2.949 7.939-5.207 0.689-3.553 0.633-8.676 0.633-8.676zM25.559 19.451h-3.329v-8.159c0-1.72-0.724-2.592-2.171-2.592-1.6 0-2.403 1.035-2.403 3.083v4.465h-3.311v-4.467c0-2.048-0.803-3.083-2.403-3.083-1.447 0-2.171 0.873-2.171 2.592v8.159h-3.329v-8.404c0-1.719 0.437-3.084 1.316-4.093 0.907-1.011 2.092-1.528 3.565-1.528 1.704 0 2.995 0.655 3.848 1.965l0.828 1.391 0.829-1.391c0.853-1.311 2.144-1.965 3.848-1.965 1.472 0 2.659 0.517 3.565 1.528 0.877 1.009 1.315 2.375 1.315 4.093z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-2483c822";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var MastodonIcon = __vue_component__;
export { MastodonIcon as default };